const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardiology(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 68 68",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "cardiology_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3008",
    d: "M68,3l0,62c0,1.656 -1.344,3 -3,3l-62,0c-1.656,0 -3,-1.344 -3,-3l0,-62c0,-1.656 1.344,-3 3,-3l62,0c1.656,0 3,1.344 3,3Z",
    style: {
      fill: "#eceef3",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5866",
    d: "M12.137,64.674l43.729,0c5.001,0.007 9.124,-4.099 9.139,-9.1l0,-42.474c-0.015,-5.001 -4.138,-9.106 -9.139,-9.1l-43.728,0c-5.001,-0.007 -9.124,4.099 -9.139,9.1l0,42.479c0.015,5.001 4.138,9.106 9.139,9.1l-0.001,-0.005Zm-7.411,-51.576c0.013,-4.055 3.357,-7.383 7.412,-7.376l43.729,0c4.055,-0.007 7.399,3.321 7.412,7.376l0,42.479c-0.013,4.055 -3.357,7.383 -7.412,7.376l-43.73,0c-4.055,0.007 -7.399,-3.321 -7.412,-7.376l0.001,-42.479Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5867",
    d: "M12.771,46.991l42.466,0c0.424,-0.004 0.771,-0.354 0.771,-0.778c0,-0.002 0,-0.005 0,-0.007l0,-32.416c0,-0.002 0,-0.005 0,-0.007c0,-0.424 -0.347,-0.774 -0.771,-0.778l-42.465,0c-0.424,0.004 -0.771,0.354 -0.771,0.778c-0,0.002 -0,0.005 0,0.007l0,32.416c-0,0.002 -0,0.005 -0,0.007c-0,0.424 0.347,0.774 0.771,0.778l-0.001,0Zm0.766,-32.416l40.922,0l0,30.845l-40.917,0l-0.005,-30.845Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    d: "M15.82,55.671c2.095,-0.001 3.818,-1.724 3.818,-3.819c0,-2.095 -1.724,-3.819 -3.819,-3.819c-2.095,0 -3.819,1.724 -3.819,3.819c0,2.095 1.724,3.819 3.819,3.819c0,0 0.001,0 0.001,0Zm0,-6.069c1.233,0.001 2.248,1.016 2.248,2.249c0,1.234 -1.015,2.249 -2.249,2.249c-1.234,-0 -2.249,-1.015 -2.249,-2.249c0,-1.234 1.015,-2.249 2.249,-2.249c0,-0 0.001,-0 0.001,0Z",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5869",
    d: "M26.789,49.183l-3.774,0c-0.431,0 -0.785,0.354 -0.785,0.785l-0,3.775c-0,0.431 0.354,0.785 0.785,0.785l3.774,0c0.431,0 0.785,-0.354 0.785,-0.785l-0,-3.775c-0,-0.431 -0.354,-0.785 -0.785,-0.785Zm-0.785,3.775l-2.2,0l-0,-2.2l2.2,0l-0,2.2Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5870",
    d: "M40.662,51.07l-9.917,-0c-0.431,0 -0.785,0.354 -0.785,0.785c0,0.431 0.354,0.785 0.785,0.785l9.917,-0c0.431,0 0.785,-0.354 0.785,-0.785c0,-0.431 -0.354,-0.785 -0.785,-0.785Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5871",
    d: "M46.439,51.07l-1.48,-0c-0.431,-0 -0.785,0.354 -0.785,0.785c-0,0.431 0.354,0.785 0.785,0.785l1.48,-0c0.431,0 0.785,-0.354 0.785,-0.785c0,-0.431 -0.354,-0.785 -0.785,-0.785Z",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    d: "M50.356,35.138l-12.739,0c-0.276,0.001 -0.531,0.152 -0.665,0.394l-1.582,2.822l-2.657,-9.6c-0.086,-0.323 -0.373,-0.554 -0.707,-0.57c-0.334,-0.014 -0.64,0.193 -0.75,0.509l-2.417,6.6l-11.186,0c-0.431,0 -0.785,0.354 -0.785,0.785c0,0.431 0.354,0.785 0.785,0.785l11.718,0c0.322,-0.002 0.61,-0.207 0.719,-0.51l1.783,-4.867l2.518,9.1c0.081,0.301 0.336,0.524 0.645,0.565c0.031,0.004 0.062,0.006 0.093,0.006c0.276,-0.001 0.531,-0.152 0.665,-0.394l2.267,-4.046l12.295,0c0.431,0 0.785,-0.354 0.785,-0.785c0,-0.431 -0.354,-0.785 -0.785,-0.785c0,0 0,-0.009 0,-0.009Z",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    d: "M47.748,17.592c-1.035,-0.004 -2.038,0.365 -2.824,1.039c-0.789,-0.681 -1.797,-1.056 -2.839,-1.056c-2.384,-0 -4.345,1.961 -4.345,4.345c-0,1.158 0.462,2.269 1.284,3.084l2.778,2.777c0.807,0.811 1.905,1.267 3.049,1.266l0.12,-0c1.151,0.006 2.257,-0.451 3.069,-1.266l2.781,-2.776c0.815,-0.814 1.273,-1.919 1.273,-3.071c-0,-2.381 -1.96,-4.341 -4.341,-4.341c-0.001,-0 -0.002,-0 -0.003,0l-0.002,-0.001Zm1.962,6.3l-2.777,2.777c-0.525,0.523 -1.239,0.814 -1.98,0.806l-0.078,0c-0.734,0.004 -1.44,-0.286 -1.959,-0.806l-2.778,-2.777c-0.538,-0.522 -0.842,-1.241 -0.842,-1.991c-0,-1.523 1.252,-2.775 2.775,-2.775c0.75,-0 1.469,0.304 1.991,0.842l0.308,0.308c0.304,0.304 0.805,0.304 1.109,0l0.309,-0.308c1.093,-1.037 2.83,-1.037 3.923,0c1.071,1.079 1.071,2.845 -0,3.924l-0.001,0Z",
    style: {
      fill: "#6dc073",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiology);
export default __webpack_public_path__ + "static/media/cardiology.f60cb822e554de3ecfb5c2649da5983f.svg";
export { ForwardRef as ReactComponent };